<template>
    <span
        :key="componentKey"
        class="sbs-dot-loader"
        :class="dotClasses">
        <span class="sbs-dot-loader__dots">
            <i
                v-for="(dot, index) in amount"
                :key="index"
                class="sbs-dot-loader__dot"
                :style="getDotStyles(index)"></i>
        </span>
    </span>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { isArrayContainsValue } from '../../utils/validators.js';
import {
    AllShapes,
    DOT_SHAPES,
} from '../../utils/shapes.js';
import {
    AllSizes,
    DOT_SIZES,
} from '../../utils/sizes.js';

export default {
    name: 'SbsDotLoader',
    mixins: [themesMixin],
    data() {
        return {
            componentKey: 0,
        };
    },
    computed: {
        animationDelay() {
            return this.animationDuration / this.amount;
        },
        dotClasses() {
            const classes = [...this.themeClasses];

            if (this.shape) {
                classes.push(this.shape);
            }

            if (this.size) {
                classes.push(this.size);
            }

            return classes;
        },
    },
    methods: {
        getDotStyles(index) {
            const delay = this.animationDelay * index;

            return {
                animationDuration: `${this.animationDuration}s`,
                animationDelay: `${delay}s`,
            };
        },
    },
    props: {
        /**
         * Количество анимированных элементов
         */
        amount: {
            type: Number,
            default: 3,
        },
        /**
         * Длительность анимации элементов
         */
        animationDuration: {
            type: Number,
            default: 0.75,
        },
        /**
         * Форма анимированных элементов
         */
        shape: {
            type: String,
            default: AllShapes.CIRCLE,
            validator: isArrayContainsValue(DOT_SHAPES),
        },
        /**
         * Размер анимированных элементов
         */
        size: {
            type: String,
            default: AllSizes.MEDIUM,
            validator: isArrayContainsValue(DOT_SIZES),
        },
    },
    watch: {
        /* Принудительная перерисовка компонента для корректного отображения анимации */
        amount() {
            this.componentKey += 1;
        },
    },
};
</script>

<style lang="scss">
/** Массив с размерами элементов */
$dot-sizes: (
    "small": 5px,
    "medium": 10px,
    "large": 15px,
    "x-large": 20px,
    "xx-large": 25px,
);

.sbs-dot-loader {
    display: flex;

    &__dots {
        position: relative;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
    }

    &__dot {
        margin-right: 5px;
        margin-left: 6px;
        background-color: $current-color;
        animation-name: pulse;
        animation-timing-function: ease;
        animation-iteration-count: infinite;
        animation-direction: alternate;

        /** Перебор массива с размерами элементов и присвоение значения */
        @each $size, $value in $dot-sizes {
            .sbs-dot-loader.#{$size} & {
                width: $value;
                height: $value;
            }
        }

        &:first-child {
            margin-left: 0;
        }

        &:last-child {
            margin-right: 0;
        }

        .sbs-dot-loader.circle & {
            border-radius: $rounded-circle;
        }

        .sbs-dot-loader.square & {
            border-radius: 0;
        }
    }
}
</style>
